module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-700.4baea1b0.ttf";